import tracking from "../../../utils/tracking";
import moment from 'moment';
import countries from "@/data/countries.json"

const regexes = {
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};

export default (formName, routeProps, successCallback) => state => {
  let formValid = true;
  state.loading = true;
  const countryVal = state.fields.country ? state.fields.country.value : '';
  const countryOption = countries.find(c => c.abbr === countryVal);
  const legalAge = countryOption ? +(countryOption.legalAge || "21") : 21;

  Object.keys(state.fields).forEach(key => {

    
    const input = state.fields[key];
    
    input.showError = false;

    if (input.optional) {
      return;
    }
    
    if (key === "dob") {
      if (!input.day || !input.month || !input.year) {
        formValid = false;
        input.showError = true;
      }
      let formattedDate = `${input.month}/${input.day}/${input.year}`
      const birthday = moment(formattedDate, 'MM/DD/YYYY').startOf('day');
      const now = moment().startOf('day');

      const diff = now.diff(birthday, 'years');

      if (diff < legalAge) {
        formValid = false;
        input.showError = true;
      }

      return;
    }

    if (!input.value || (regexes[key] && !regexes[key].test(input.value))) {
      if(key != "subscribe_brand_news_optional"){
        formValid = false;
        input.showError = true;
        if(key=="paragraph"){
          input.showError = "*This field is required"
        }
      }
   
      
      
    }
    

    if(key == "paragraph" && (input.value.length > input.limit)){
      formValid = false;
      input.showError = `Please make sure your input is less than ${input.limit} characters`
    
    }
  });

  if (!formValid) {
    tracking.event("customEvent", {
      eventCategory: formName,
      eventAction: "Validation fail",
      eventLabel: `source: ${routeProps.location.pathname} - ${Object.keys(
        state.fields
      )
        .filter(key => state.fields[key].showError)
        .join(", ")}`
    });
    state.loading = false;
  }

  if (formValid && successCallback) {
    successCallback.call();
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/components/_common/Form/validate.js